import SocialButton from './SocialButton';

export * from './SocialButton';

export default SocialButton;
